import DialogService from "./../../_services/DialogService";
import { User } from "../../_models/user";
// import { AuthenticationService, AttendanceService, LessonPlanService } from 'src/app/_services';
import { FunctionComponent, useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthenticationService from "../../_services/AuthenticationService";
import AttendanceService from "../../_services/AttendanceService";
import LessonPlanService from "../../_services/LessonPlanService";
import attendanceImage from "../../assets/img/attendance.png";
import lessonPlanImage from "../../assets/img/lessonplan.png";
import timeTableImage from "../../assets/img/timetable.png";
import qrcodeimage from "../../assets/img/qr-code.png";
import arrowUpImage from "../../assets/img/arrow-up.png";
import arrowDownImage from "../../assets/img/arrow-down.png";
import announcementImage from "../../assets/img/announcement.png";
import "./tab-activities.css";
import { ConfirmDialog } from "../../_components/confirm-dialog/confirmDialog";
import { AlertDialog } from "../../_components/alert-dialog/AlertDialog";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
// import { AlertDialog } from '../../_components/alert-dialog/AlertDialog';

type MyProps = {};
export const TabActivities: FunctionComponent<MyProps> = ({}) => {
  const { isUsingCacheMethod } = useContext(AppPropertiesContext);

  var History = useHistory();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [alertTitle, setalertTitle] = useState("ALERT");
  const [confirmTitle, setconfirmTitle] = useState("PLEASE CONFIRM");
  const [showAlert, setShowAlert] = useState(false);
  const [confirmId, setConfirmId] = useState(-1);

  const [currentUser, setCurrentUser] = useState<User>();
  const [lastSyncInDate, setLastSyncInDate] = useState<string>("");
  let ATTENDANCE_CONFIG: any = JSON.parse(localStorage.getItem("initData"));
  var lastSyncOutDate: string = "";
  let lessonplanservice: LessonPlanService = new LessonPlanService();

  useEffect(() => {
    setCurrentUser(AuthenticationService.currentUserValue);
    console.log("in UseEffect");
    // ATTENDANCE_CONFIG =;
    initSyncDates();
  }, []);

  function initSyncDates(): void {
    console.log(ATTENDANCE_CONFIG);
    let _lastSyncInDate = localStorage.getItem("lastSyncInDate");
    if (_lastSyncInDate != null) {
      setLastSyncInDate(_lastSyncInDate);
      let _lastSyncOutDate = localStorage.getItem("lastSyncOutDate");
      if (_lastSyncOutDate != null) {
        lastSyncOutDate = _lastSyncOutDate;
      }
    }
  }

  function syncIn(): void {
    AttendanceService.getScheduleActivitySlotsBySyncStatus(0).then((data) => {
      if (data.length > 0) {
        showAlertDialog(
          "Alert: You need to Sync Out the existing data before you perform Sync In"
        );
      } else {
        History.push("/syncIn");
      }
    });
  }

  function attendance() {
    if ((
      ATTENDANCE_CONFIG &&
      ATTENDANCE_CONFIG.attendanceEnableStatus &&
      ATTENDANCE_CONFIG.attendanceEnableStatus === true) ||  !isUsingCacheMethod()
    ) {
      History.push("/attendance");
    } else {
      showAlertDialog("Please syncIn and try again.");
    }
  }

  const lessonplan = () => {
    console.log(ATTENDANCE_CONFIG);
    if ((

      ATTENDANCE_CONFIG &&
      ATTENDANCE_CONFIG.lessonplanEnableStatus &&
      ATTENDANCE_CONFIG.lessonplanEnableStatus === true
      ) || !isUsingCacheMethod()
    ) {
      History.push("/lessonplan");
    }else {
      showAlertDialog("Please syncIn and try again.");
    }
  };

  function products(): void {
    alert("Products");
  }

  function staffLocationAttendance(): void {
    History.push("/staffLocationAttendance");
  }

  function syncOut(): void {
    let attendanceCount = 0;
    let lessonplanCount = 0;
    AttendanceService.getScheduleActivitySlotsBySyncStatus(0).then((data) => {
      if (data.length > 0) {
        attendanceCount = data.length;
      }
      lessonplanservice
        .getLessonPlanStepStatusesBySyncStatus(0)
        .then((lpsdata) => {
          if (lpsdata.length > 0) {
            lessonplanCount = lpsdata.length;
          }
          displaySyncConfirmDialog(attendanceCount, lessonplanCount);
        });
    });
  }

  function displaySyncConfirmDialog(
    attendanceCount: number,
    lessonplanCount: number
  ) {
    if (attendanceCount > 0 || lessonplanCount > 0) {
      let message =
        "Attendace classes: <b>" +
        attendanceCount +
        "</b><br/>" +
        "Lessonplan Statuses: <b>" +
        lessonplanCount +
        "</b>";
      console.log("inside displaySyncConfirm");
      setMessage(message);
      setShowConfirmDialog(true);
      setConfirmId(1);
      // this.setState({showConfirmDialog:true,message:message})
      // const confirmed = DialogService.confirm(message,'Confirm sync-out', )
    } else {
      console.log("in else");
      showAlertDialog("Nothing found to sync-out!");
      // console.log("inside else")
      //  <AlertDialog title="Alert" message="Nothing found to sync-out!" btnOkText="Ok" size="sm"/>
      // if(confirmed)
      //   console.log('User confirmed:', confirmed);
      // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)');
    }
  }

  function Inventory(): void {
    History.push("/inventory");
  }
  const testAnalysis =(): void=> {
    History.push("/testAnalysis");
  }

  const arReports = (): void => {
    History.push("/ar-reports");
  }

  function TimeTable(): void {
    History.push("/timetable");
  }

  function showAlertDialog(message: string) {
    console.log(message);
    setMessage(message);
    setShowAlert(true);
    // if(confirmed) console.log('User confirmed:', confirmed))
    // .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }
  function handleConfirm(flag) {
    setShowConfirmDialog(false);
    if (confirmId === 1) {
      if (flag) {
        History.push("/syncOut");
      } else
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        );
    }
  }
  function handleAlert(flag) {
    setShowAlert(false);
  }
  return (
    <div className="tab-activities">
      {showConfirmDialog && (
        <ConfirmDialog
          message={message}
          title={confirmTitle}
          btnOkText="OK"
          btnCancelText="CANCEL"
          size="lg"
          handleResult={handleConfirm}
        />
      )}
      {showAlert && (
        <AlertDialog
          message={message}
          title={alertTitle}
          btnOkText="OK"
          size="sm"
          close={handleAlert}
        />
      )}
      <div className="row">
        <div className="col">
          <div
            className="tile tile-double tile-title icon bg-color-green"
            onClick={() => attendance()}
          >
            <div className="tile-content text-center">
              <img src={attendanceImage} alt="" width="96px" height="96px" />
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">Attendance</div>
            </div>
          </div>
        </div>
        <div className="col">
          <div
            className="tile tile-title icon bg-color-blue"
            onClick={() => lessonplan()}
          >
            <div className="tile-content text-center">
              <img src={lessonPlanImage} alt="" width="48px" height="48px" />
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">Lesson Plan</div>
            </div>
          </div>

          <div
            className="tile tile-title icon bg-color-yellow"
            onClick={() => TimeTable()}
          >
            <div className="tile-content text-center">
              <img src={timeTableImage} alt="" width="48px" height="48px" />
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">Timetable</div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div
            className="tile tile-title icon bg-color-purple"
            onClick={() => Inventory()}
          >
            <div className="tile-content text-center">
              <img src={qrcodeimage} alt="" width="48px" height="48px" />
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">Inventory</div>
            </div>
          </div>
        </div>
        <div className="col">
          <div
            className="tile tile-title icon bg-color-orangeDark"
            onClick={() => staffLocationAttendance()}
          >
            <div className="tile-content text-center">
              <img src={attendanceImage} alt="" width="48px" height="48px" />
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">Staff Attendance</div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div
            className="tile tile-title icon bg-color-green1"
            onClick={() => testAnalysis()}
          >
            <div className="tile-content text-center">
              {/* <img src={qrcodeimage} alt="" width="48px" height="48px" /> */}
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">Test Analysis</div>
            </div>
          </div>
        </div>
        <div className="col">
          <div
            className="tile tile-title icon bg-color-pink"
            onClick={()=> History.push("/tde")}
          >
            <div className="tile-content text-center">
              
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">TDE</div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div
            className="tile tile-title icon bg-color-blue"
            onClick={() => arReports()}
          >
            <div className="tile-content text-center">
              <img src={announcementImage} alt="" width="48px" height="48px" />
            </div>
            <div className="brand">
              <div className="badge"></div>
              <div className="name">AR Reports</div>
            </div>
          </div>
        </div>
        <div className="col">
        </div>
      </div>

      {isUsingCacheMethod ? null : (
        <div className="row">
          <div className="col">
            <div
              className="tile tile-title icon bg-color-green1"
              onClick={() => syncIn()}
            >
              <div className="tile-content">
                Last Sync In
                <div id="lastsyncindate">{lastSyncInDate}</div>
                <img src={arrowDownImage} alt="" width="48px" height="48px" />
              </div>
              <div className="brand">
                <div className="badge"></div>
                <div className="name">Sync In</div>
              </div>
            </div>
          </div>
          <div className="col">
            <div
              className="tile tile-title icon bg-color-red1"
              onClick={() => syncOut()}
            >
              <div className="tile-content">
                Last Sync Out
                <div id="lastsyncoutdate">{lastSyncOutDate}</div>
                <img src={arrowUpImage} alt="" width="48px" height="48px" />
              </div>
              <div className="brand">
                <div className="badge"></div>
                <div className="name">Sync Out</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
